<template>
  <div>
    <form-validator v-model="formValid">
      <form @submit.prevent>
        <div class="row mb-3">
          <div class="col-md-6">
            <username-suggest :value="form_data.uid" @input="updateUid" :fname="fname" :lname="lname" ref="uid" required @form-state="updateUidValid($event)"/>
          </div>
        </div>
        <password-form :suggestions-in-modal="true" :isNewPassword="false" :hide-password-notifications="true" @input="updatePassword" @form-state="updatePasswordValid"/>
      </form>
    </form-validator>
  </div>
</template>

<script>
import FormValidator from '../FormValidator.vue'
import UsernameSuggest from './UsernameSuggest'
import PasswordForm from "../PasswordForm.vue";

export default {
  emits: ['form-state', 'form-invalid', 'form-valid', 'input'],
  data () {
    return {
      name: 'validate-new-password',
      formValid: false,
      form_data: {
        uid: '',
        password: ''
      },
      uidValid: false,
      passwordValid: false
    }
  },
  props: ['value', 'fname', 'lname'],
  computed: {
    formData () {
      return this.form_data
    },
    formIsValid() {
      return this.uidValid && this.passwordValid;
    }
  },
  methods: {
    updateUid(val){
      this.form_data.uid = val
    },
    updateUidValid(val){
      this.uidValid = val;
    },
    updatePassword(data) {
      this.form_data.password = data.password;
    },
    updatePasswordValid(val) {
      this.passwordValid = val;
    }
  },
  watch:{
    formIsValid(newv) {
      this.$emit(newv ? 'form-valid' : 'form-invalid')
    },
    formData: {
      handler (new_val) {
        this.$emit('input', new_val);
      },
      deep: true
    },

  },
  components: {
    FormValidator,
    UsernameSuggest,
    PasswordForm
  }
}
</script>



// WEBPACK FOOTER //
// UserForm.vue?79c50298